import React, { forwardRef } from 'react';

interface IProps {
  title: string;
  className: string;
  id?: string;
  testId?: string;
  type?: string;
}

const Heading = forwardRef<HTMLHeadingElement, IProps>(({ title, className, id, testId, type }, ref) => {
  const getMarkup = () => title;
  return type === 'HTML' ? (
    // eslint-disable-next-line react/no-danger
    <h1
      ref={ref}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: getMarkup() }}
      id={`${id ?? 'heading'}`}
      className={className}
      data-testid={testId}
    />
  ) : (
    <h1 ref={ref} id={`${id ?? 'heading'}`} className={className} data-testid={testId}>
      {title}
    </h1>
  );
});

Heading.displayName = 'Heading';

export default Heading;
